<template>
  <Header>
    <DashBoardNav :PCTRLLOG="CTRLLOG"></DashBoardNav>
  </Header>
</template>

<script>
import Header from '@/components/layouts/Header'
import DashBoardNav from '@/views/DashBoard/DashBoardNav'
import { mapState } from 'vuex'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  name: 'DashBoardHeader',
  componentName: 'DashBoardHeader',
  components: {
    Header,
    DashBoardNav
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    height: {
      type: String,
      default: '0px'
    }
  },
  computed: {
  },
  watch: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/DashBoard/DashBoardHeader.vue